/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Launchers/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import MissingInfoModal from './MissingInfoModal/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Launchers({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/Apps/Content/Launchers",
  innerRef,
  left,
  top
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Content'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 innerRef={innerRef}
 left={left}
 top={top}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'MissingInfoModal'}>
<MissingInfoModal
  viewPath={`${viewPath}/MissingInfoModal`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}